if (!customElements.get('modular-blog')) {
  customElements.define('modular-blog', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.body = this.querySelector('[data-article-body]');
      if (!this.body) return;

      this.mountInlineCards();
      this.setupQuickAnswer();

      // 仅包装正文表格，避免长表格撑开整页，也保留原有表格内容。
      this.body.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('mb-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'mb-table-scroll';
        wrapper.tabIndex = 0;
        table.before(wrapper);
        wrapper.append(table);
      });

      this.toc = this.querySelector('[data-toc]');
      if (this.toc) this.setupToc(signal);

      // 标记标题的锚点补齐后，恢复直接链接的位置。
      if (location.hash) {
        let target;
        try {
          target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        } catch {
          target = null;
        }
        if (target && this.contains(target) && !target.closest('[hidden]')) {
          const question = target.closest('details');
          if (question) question.open = true;
          this.navigationFrame = requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
        }
      }
    }

    setupQuickAnswer() {
      if (this.body.querySelector('.mb-quick-answer')) return;
      const legacy = this.body.querySelector('blockquote');
      const title = legacy?.querySelector('p:first-child > strong:only-child');
      if (title?.textContent.trim() !== 'Quick Answer') return;

      // 兼容已经粘贴的旧版正文，仅补齐 Quick Answer 的图标与容器。
      legacy.classList.add('mb-quick-answer');
      const icon = document.createElement('span');
      icon.className = 'mb-quick-answer__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '✦';
      const copy = document.createElement('div');
      copy.className = 'mb-quick-answer__copy';
      copy.append(...legacy.childNodes);
      legacy.append(icon, copy);
    }

    mountInlineCards() {
      let productCards = [];
      let collectionCard;
      const sources = this.querySelectorAll('[data-inline-product-source], [data-inline-collection-source]');
      sources.forEach(source => {
        const cards = source.querySelectorAll('.mb-inline-product');
        const card = cards[0];
        const isProductSource = source.hasAttribute('data-inline-product-source');
        if (isProductSource) productCards = cards;
        else collectionCard = card;
        const targetId = source.dataset.inlineProductTarget || source.dataset.inlineCollectionTarget;
        if (!targetId) return;
        const target = this.body.querySelector(`#${CSS.escape(targetId)}`);
        if (!target || !card) return;
        // 兼容旧文章的 ID 占位。
        target.replaceChildren(isProductSource ? card.cloneNode(true) : card);
        target.hidden = false;
      });

      // 只匹配整段占位文案，正文产品卡按列表顺序逐个消耗。
      let productIndex = 0;
      this.body.querySelectorAll('p').forEach(paragraph => {
        const placeholder = paragraph.textContent.trim();
        const isProduct = placeholder === '[[Product Card]]';
        const isCollection = placeholder === '[[Collection Card]]';
        if (!isProduct && !isCollection) return;
        if (paragraph.closest('.mb-inline-product')) return;
        const card = isProduct ? productCards[productIndex++] : collectionCard?.cloneNode(true);
        if (card) paragraph.replaceWith(card);
        else paragraph.remove();
      });
      sources.forEach(source => source.remove());
    }

    setupToc(signal) {
      // 直接采集正文标题，排除动态插入的卡片及隐藏内容。
this.headings = [...this.body.querySelectorAll('h2')]
  .filter(heading => {
    const title = heading.textContent.trim();

    return (
      title &&
      title.toLowerCase() !== 'quick answer' &&
      !heading.closest('[hidden], .mb-inline-product')
    );
  });
      if (!this.headings.length) return;
      const nav = this.querySelector('[data-toc-links]');
      nav.replaceChildren();
      this.links = new Map();
      this.headingGroups = new Map();
      this.tocGroups = new Map();
      const fragment = document.createDocumentFragment();
      let parentGroup;

      this.headings.forEach((heading, index) => {
        // 保留有效锚点；重复或缺失的 ID 使用实例前缀，避免影响其它模块。
        if (!heading.id || document.getElementById(heading.id) !== heading) {
          const base = `${this.id}-heading-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.className = 'mb-toc__sub';
        this.links.set(heading.id, link);
        if (heading.tagName === 'H2') {
          const wrapper = document.createElement('div');
          wrapper.className = 'mb-toc__group';
          const row = document.createElement('div');
          row.className = 'mb-toc__row';
          row.append(link);
          wrapper.append(row);
          fragment.append(wrapper);
          parentGroup = { wrapper, row, parentLink: link, title: link.textContent };
        } else if (parentGroup) {
          // 只有实际包含 H3 的章节才生成展开按钮，默认收起二级目录。
          if (!parentGroup.panel) {
            const panel = document.createElement('div');
            let panelId = `${this.id}-toc-sub-${index + 1}`;
            while (document.getElementById(panelId)) panelId += '-sub';
            panel.id = panelId;
            panel.className = 'mb-toc__children';
            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'mb-toc__toggle';
            toggle.setAttribute('aria-controls', panel.id);
            const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            icon.setAttribute('viewBox', '0 0 16 16');
            icon.setAttribute('aria-hidden', 'true');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'm4 6 4 4 4-4');
            icon.append(path);
            toggle.append(icon);
            Object.assign(parentGroup, { panel, toggle });
            this.tocGroups.set(panel.id, parentGroup);
            this.setTocGroupExpanded(parentGroup, false);
            parentGroup.row.append(toggle);
            parentGroup.wrapper.append(panel);
          }
          parentGroup.panel.append(link);
          this.headingGroups.set(heading.id, parentGroup);
        } else {
          // 没有上级 H2 的 H3 仍保留跳转入口。
          fragment.append(link);
        }
      });
      nav.append(fragment);
      try {
        this.setTocGroupExpanded(this.headingGroups.get(decodeURIComponent(location.hash.slice(1))), true);
      } catch {
        // 非法编码的外部锚点不影响目录初始化。
      }
      this.querySelector('[data-toc-slot]').hidden = false;
      this.desktop = matchMedia('(min-width: 1100px)');
      const updateMode = () => { this.toc.open = this.desktop.matches; };
      updateMode();
      this.desktop.addEventListener('change', updateMode, { signal });

      nav.addEventListener('click', event => {
        const toggle = event.target.closest('.mb-toc__toggle');
        if (toggle) {
          const group = this.tocGroups.get(toggle.getAttribute('aria-controls'));
          this.setTocGroupExpanded(group, toggle.getAttribute('aria-expanded') !== 'true');
          return;
        }
        const link = event.target.closest('a');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!heading) return;
        event.preventDefault();
        event.stopPropagation();
        this.setActive(heading.id);
        const question = heading.closest('details');
        if (question) question.open = true;
        if (!this.desktop.matches) this.toc.open = false;
        // 等折叠面板完成布局后再计算滚动位置。
        cancelAnimationFrame(this.navigationFrame);
        this.navigationFrame = requestAnimationFrame(() => {
          history.replaceState(null, '', link.hash);
          heading.tabIndex = -1;
          heading.focus({ preventScroll: true });
          heading.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' });
          this.navigationFrame = null;
        });
      }, { signal });
    }

    setTocGroupExpanded(group, expanded) {
      if (!group?.panel) return;
      group.panel.hidden = !expanded;
      group.toggle.setAttribute('aria-expanded', String(expanded));
      group.toggle.setAttribute('aria-label', `${expanded ? 'Hide' : 'Show'} subsections: ${group.title}`);
    }

    setActive(id) {
      if (this.activeId === id) return;
      this.links.get(this.activeId)?.removeAttribute('aria-current');
      this.links.get(id)?.setAttribute('aria-current', 'location');
      this.activeParent?.removeAttribute('data-active-descendant');
      this.activeParent = this.headingGroups.get(id)?.parentLink;
      this.activeParent?.setAttribute('data-active-descendant', '');
      this.activeId = id;
    }

    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.navigationFrame);
      this.navigationFrame = null;
      this.controller = null;
      this.activeId = null;
      this.activeParent = null;
    }
  });
}
